import React, { useState, useEffect } from 'react';

import AsyncSelect from 'react-select/async';
import Axios from '../../AxiosConfig';

const CustomOption = ({ innerProps, isDisabled, data }) =>
    !isDisabled ? (
        <div {...innerProps}>
            <div className='cursor-pointer p-2 hover:bg-gray-100'>
                <span className='text-sm font-medium text-gray-700 block mb-0'>{data.label}</span>
                <span className='text-sm text-gray-600 mt-0'>
                    {Object.keys(data.data).filter((key) => {
                        return key !== '_id' && key !== 'name' && key !== 'uuid';
                    }).map((key, index) => {
                        return (
                            <span key={index}>
                                {data.data[key]}
                                &nbsp;|&nbsp;
                            </span>
                        )
                    })}
                </span>
            </div>

        </div>
    ) : null;

const Search = ({ setParent, apiURL, defaultValue = undefined, placeholder = "Search" }) => {
    const [value, setValue] = useState("");
    const [defaultUserValue, setDefaultUserValue] = useState(defaultValue ? (defaultValue) : {});
    const getResults = (inputValue) => {
        return Axios.post(apiURL, { name: inputValue }).then(data => {
            return data.data.map((d) => ({ label: d.name, value: d, data: d }));
        });
    }
    return (
        <AsyncSelect
            cacheOptions
            loadOptions={getResults}
            defaultOptions
            onInputChange={setValue}
            onChange={(e) => setParent(e.value)}
            components={{ Option: CustomOption }}
            menuPlacement="auto"
            placeholder={placeholder}
            defaultValue={defaultUserValue.name ? { label: defaultUserValue.name, value: defaultUserValue, data: defaultUserValue } : null}
            menuPortalTarget={document.body}
            styles={{
                menuPortal: defaultStyles => ({
                    ...defaultStyles,
                    paddingBottom: '0px',
                    marginTop: '0px',
                    zIndex: 9999,
                }),
            }}
        />
    )
}
export default Search;